import get from 'lodash.get';
import PropTypes from 'prop-types';
import React from 'react';
import ReactPlayer from 'react-player/lazy';

import { useObserver } from '../../tools/useObserver';
import ContentfulImage from './ContentfulImage';
import { ArrowLink } from './Links';
import PageSection from './PageSection';
import RichTextConverter from './RichText/RichTextConverter';
import SimpleCard from './SimpleCard';
import * as styles from './ThreeUp.module.css';

const ThreeUp = ({ section, id, center = false, className = '', wide = false }) => {
  const [containerRef, isVisible] = useObserver({ threshold: 0.25 });

  const isHomepage = className === 'homepage';
  const cardMaxWidth = section.itemsPerRow === 2 ? { maxWidth: 'unset' } : {};
  const isSvg = section.mainImage && section.mainImage.file?.contentType === 'image/svg+xml';
  let heightStyle = styles.free;

  if (section.adjustForTallImage && !isSvg) {
    heightStyle = styles.heightAdjust;
  }
  let mainMedia;
  if (section.mainImage) {
    mainMedia = <ContentfulImage imageFragment={section.mainImage} className={[heightStyle, styles.svg].join(' ')} />;
  }
  if (section.wistiaUrl) {
    mainMedia = (
      <div className={`player-wrapper-${section.wistiaUrl}`}>
        <ReactPlayer
          className={`react-player-${section.wistiaUrl}`}
          controls={false}
          width={'100%'}
          height="100%"
          url={section.wistiaUrl}
        />
      </div>
    );
  }
  return (
    <PageSection
      slim
      wide={wide}
      className={[styles.section, className, className === 'homepage' && styles.homepage].join(' ')}
    >
      <div className={[wide ? styles.container : '', center ? styles.center : ''].join(' ')}>
        <div className={styles.flex}>
          <div className={styles.gridLeft}>
            {section.heading && section.headingSize === 'H2' && <h2 id={id || ''}>{section.heading}</h2>}
            {section.heading && section.headingSize !== 'H2' && <h3 id={id || ''}>{section.heading}</h3>}
            {section.sectionCopy && <RichTextConverter className={styles.shortText} copy={section.sectionCopy} />}
          </div>
          <div className={styles.gridRight}>{mainMedia}</div>
        </div>
        <div
          ref={containerRef}
          className={[styles.grid, isVisible && isHomepage && styles.fade].join(' ')}
          style={{ '--itemsPerRow': section.itemsPerRow || 3 }}
        >
          {(get(section, 'content', []) || [])
            .filter((c) => c.__typename === 'ContentfulSimpleCard')
            .map((card, i) => {
              let cardImage = !!card.image?.icon ? get(card, 'image.icon.src') : get(card, 'image.file.url');
              return (
                <SimpleCard
                  key={i}
                  style={cardMaxWidth}
                  center={center}
                  imageSrc={cardImage}
                  body={get(card, 'body')}
                  title={get(card, 'title', '')}
                  imageType={'icon'}
                  className={isHomepage ? styles.hidden : null}
                />
              );
            })}
        </div>
      </div>
      {section?.ctaUrl && <ArrowLink label={get(section, 'ctaLabel')} url={get(section, 'ctaUrl')} />}
    </PageSection>
  );
};

ThreeUp.propTypes = {
  section: PropTypes.object.isRequired,
  id: PropTypes.string,
  center: PropTypes.bool,
};

export default ThreeUp;
